import axios from "axios";
import { config } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const AddFeaturedBusinessProperty = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "FEATURED_BUSINESS_PROPERTY_ADD_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/featured-property/add`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "FEATURED_BUSINESS_PROPERTY_ADD_SUCCESS",
          payload: data,
        });
        return Promise.resolve(data);
      } else {
        dispatch({
          type: "FEATURED_BUSINESS_PROPERTY_ADD_FAIL",
          payload: data.message || "Add failed",
        });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({
        type: "FEATURED_BUSINESS_PROPERTY_ADD_FAIL",
        payload: errorMessage,
      });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const UpdateFeaturedBusinessProperty = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "FEATURED_BUSINESS_PROPERTY_UPDATE_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/featured-property/update`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "FEATURED_BUSINESS_PROPERTY_UPDATE_SUCCESS",
          payload: data,
        });
        return Promise.resolve(data);
      } else {
        dispatch({
          type: "FEATURED_BUSINESS_PROPERTY_UPDATE_FAIL",
          payload: data.message || "Update failed",
        });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({
        type: "FEATURED_BUSINESS_PROPERTY_UPDATE_FAIL",
        payload: errorMessage,
      });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const GetFeaturedBusinessPropertyList = (listData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "FEATURED_BUSINESS_PROPERTY_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/featured-property/list`,
        listData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "FEATURED_BUSINESS_PROPERTY_LIST_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "FEATURED_BUSINESS_PROPERTY_LIST_FAIL",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "FEATURED_BUSINESS_PROPERTY_LIST_FAIL",
        payload: error?.response,
      });
    }
  };
};

export const ViewFeaturedBusinessProperty = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "FEATURED_BUSINESS_PROPERTY_VIEW_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/featured-property/view/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "FEATURED_BUSINESS_PROPERTY_VIEW_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "FEATURED_BUSINESS_PROPERTY_VIEW_FAIL",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "FEATURED_BUSINESS_PROPERTY_VIEW_FAIL",
        payload: error?.response?.data?.message,
      });
    }
  };
};